export default __webpack_public_path__ + "static/media/6.f4f13373.png";